import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../sidebar/Sidebar';

/**
 * Layout — Protected page shell
 *
 * Structure (Bootstrap 5):
 *   ┌──────────┬──────────────────────────┐
 *   │ Sidebar  │  <Outlet /> (page here)  │
 *   │  260px   │  flex-grow-1 + scroll    │
 *   │  fixed   │                          │
 *   └──────────┴──────────────────────────┘
 *
 * - Sidebar handles its own fixed positioning via sidebar.css
 * - sb-main-content in sidebar.css adds margin-left:260px on desktop,
 *   resets to 0 + padding-top on mobile (hamburger space)
 * - <Outlet /> is where React Router renders the matched child page
 */
const Layout = ({ onLogout }) => {
    return (
        <div className="d-flex">

            {/* Fixed sidebar — renders both desktop aside & mobile offcanvas */}
            <Sidebar onLogout={onLogout} />

            {/* Scrollable main content area — height: 100vh so child h-100 resolves correctly */}
            <main
                className="sb-main-content flex-grow-1 overflow-hidden gtss-layout-bg d-flex flex-column"
                style={{ height: '100vh' }}
            >
                <Outlet />
            </main>

        </div>
    );
};

export default Layout;